import React from "react";
import { StarIcon } from "@heroicons/react/24/solid";

const testimonials = [
  { name: "Felix Fernandez", role: "CEO at Firefly Growth Accelerator", text: "We tested four enrichment tools side by side. Director Discovery was the only one where the data didn't need cleaning after. Everything came back accurate and ready to use." },
  { name: "Sönke Venjacob", role: "Founder at Platinum Agency", text: "The job change filter helps us reach qualified leads the moment they switch roles, before anyone else does." },
  { name: "Pete Lipton", role: "Snr. Director of Sales at Snyk", text: "We've used a lot of email finders, but Director Discovery is the only one where the emails are actually verified. The bounce rate dropped by over 70%." },
  { name: "Brigitta Ruha", role: "Founder at Growth Today", text: "Syncing lead lists to our CRM used to be clunky. With Director Discovery, it's instant and helps us act on fresh leads much faster." },
  { name: "Henry Clayton", role: "Principal SDR at Allego", text: "Finding mobile numbers from their search felt like a cheat code. It's helped us book more calls, especially with hard-to-reach leads." },
  { name: "Tai Shiver", role: "Manager of Business Development at Loopio", text: "The verified mobile number filter is a game changer. It's helped our team prioritize high-quality leads and cut through the noise." },
];

function TestimonialCard({ t }: { t: any }) {
  return (
    <div className="flex-shrink-0 w-72 bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mx-3">
      <div className="flex mb-3">
        {[...Array(5)].map((_, i) => (
          <StarIcon key={i} className="w-4 h-4 text-yellow-400" />
        ))}
      </div>
      <p className="text-sm text-gray-700 leading-relaxed mb-4 line-clamp-4">"{t.text}"</p>
      <div className="flex items-center gap-3 mt-auto">
        <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-xs flex-shrink-0">
          {t.name
            .split(" ")
            .map((n:any) => n[0])
            .join("")}
        </div>
        <div>
          <p className="text-sm font-semibold text-gray-900">{t.name}</p>
          <p className="text-xs text-gray-400">{t.role}</p>
        </div>
      </div>
    </div>
  );
}

export default function TestimonialsMarquee() {
  const doubled = [...testimonials, ...testimonials];

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-10">
        <p className="text-sm text-gray-400 font-semibold uppercase tracking-wider mb-2">Join 15,000+ companies using Director Discovery</p>
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Sales Teams Winning with Director Discovery's Data</h2>
      </div>

      {/* Marquee row 1 — left */}
      <div className="relative mb-4">
        <div className="flex animate-marquee-left">
          {doubled.map((t, i) => (
            <TestimonialCard key={i} t={t} />
          ))}
        </div>
      </div>

      {/* Marquee row 2 — right */}
      <div className="relative">
        <div className="flex animate-marquee-right">
          {[...doubled].reverse().map((t, i) => (
            <TestimonialCard key={i} t={t} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .animate-marquee-left {
          animation: marquee-left 35s linear infinite;
        }
        .animate-marquee-right {
          animation: marquee-right 35s linear infinite;
        }
      `}</style>
    </section>
  );
}
